module.exports = __webpack_public_path__ + "900ea9c2eb801bd294bafcbf41fe6772.jpg";